<template>
  <div class="rose-chart">
    <div class="title">
      <span>产品类型销售额统计(万元)</span>
    </div>
    <div id="SaleTypeAmountRoseChart" class="chart-container"></div>
  </div>
</template>

<script>
import * as echarts from 'echarts'
import { productSale } from '@/api/dashboard'
import to from 'await-to'

let myChart
let currentIndex = -1
let autoPlayTimer

const gradientColors = [
  {
    type: 'linear',
    x: 0,
    y: 0,
    x2: 0,
    y2: 1,
    colorStops: [
      { offset: 0, color: '#00E5FF' },
      { offset: 1, color: '#0088CC' },
    ],
  },
  {
    type: 'linear',
    x: 0,
    y: 0,
    x2: 0,
    y2: 1,
    colorStops: [
      { offset: 0, color: '#448BFF' },
      { offset: 1, color: '#0057FF' },
    ],
  },
  {
    type: 'linear',
    x: 0,
    y: 0,
    x2: 0,
    y2: 1,
    colorStops: [
      { offset: 0, color: '#B366FF' },
      { offset: 1, color: '#8B46CC' },
    ],
  },
  {
    type: 'linear',
    x: 0,
    y: 0,
    x2: 0,
    y2: 1,
    colorStops: [
      { offset: 0, color: '#FFD666' },
      { offset: 1, color: '#E6A800' },
    ],
  },
]

export default {
  data() {
    return {
      data: [],
    }
  },
  mounted() {
    myChart = echarts.init(document.getElementById('SaleTypeAmountRoseChart'))
    window.addEventListener('resize', () => {
      myChart.resize()
    })
    this.initData()
    setInterval(() => {
      this.initData()
    }, process.env.VUE_APP_LTIME)
    myChart.on('mouseover', () => {
      this.stopAutoPlay()
    })
    myChart.on('mouseout', () => {
      this.startAutoPlay()
    })
  },
  beforeDestroy() {
    myChart.dispose()
    this.stopAutoPlay()
  },
  methods: {
    async initData() {
      const [res, err] = await to(productSale({ type: 3 }))
      if (err) return
      this.data = res.data
      this.setChartOption(res.data)
      this.startAutoPlay()
    },
    setChartOption(data) {
      const chartData = data.map((item, index) => ({
        value: item.amount,
        name: item.typeName,
        itemStyle: {
          color: gradientColors[index % gradientColors.length],
        },
      }))

      const option = {
        tooltip: {
          trigger: 'item',
          backgroundColor: 'rgba(5, 13, 76, 0.8)',
          borderColor: '#00B4D8',
          borderWidth: 1,
          textStyle: {
            color: '#fff',
            fontSize: 14,
          },
          formatter: '{b}<br/>销售额: {c} 万元<br/>占比: {d}%',
        },
        legend: {
          orient: 'vertical',
          right: '5%',
          top: 'center',
          icon: 'rect',
          itemWidth: 14,
          itemHeight: 14,
          itemGap: 15,
          columnGap: 40,
          padding: [0, 0, 0, 0],
          textStyle: {
            color: '#FFFFFF',
            fontSize: 16,
          },
          data: chartData.map((item, index) => ({
            name: item.name,
            itemStyle: {
              color: gradientColors[index % gradientColors.length],
            },
          })),
        },
        series: [
          {
            name: '产品类型销售额统计',
            type: 'pie',
            radius: ['0%', '80%'],
            center: ['30%', '50%'],
            avoidLabelOverlap: true,
            itemStyle: {
              borderRadius: 6,
              borderColor: 'rgba(5, 13, 76, 0.3)',
              borderWidth: 1,
            },
            label: {
              show: true,
              position: 'inside',
              color: '#FFFFFF',
              fontSize: 18,
              fontWeight: 'bold',
              formatter: '{c}',
            },
            labelLine: {
              show: false,
            },
            emphasis: {
              scaleSize: 15,
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: 'rgba(0, 0, 0, 0.5)',
              },
            },
            data: chartData.sort((a, b) => b.value - a.value),
          },
        ],
      }

      myChart.setOption(option)
    },
    startAutoPlay() {
      this.stopAutoPlay()
      const dataLen = this.data.length
      if (dataLen === 0) return

      autoPlayTimer = setInterval(() => {
        myChart.dispatchAction({
          type: 'downplay',
          seriesIndex: 0,
        })
        currentIndex = (currentIndex + 1) % dataLen
        myChart.dispatchAction({
          type: 'highlight',
          seriesIndex: 0,
          dataIndex: currentIndex,
        })
        myChart.dispatchAction({
          type: 'pieToggleSelect',
          seriesIndex: 0,
          dataIndex: currentIndex,
        })
      }, 2000)
    },
    stopAutoPlay() {
      if (autoPlayTimer) {
        clearInterval(autoPlayTimer)
        autoPlayTimer = null
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.rose-chart {
  position: relative;
  height: 100%;
  box-sizing: border-box;

  .title {
    position: relative;
    width: 100%;
    height: 70px;
    background: url('~@/img/agriculture/title_bg.png') 100% 100%;
    border-radius: 7px 7px 0px 0px;
    font-weight: bold;
    font-size: 30px;
    color: #fefefe;
    line-height: 70px;
    padding-left: 47px;

    span {
      position: relative;
      z-index: 9;
    }

    &::after {
      z-index: 8;
      content: '';
      position: absolute;
      left: 25px;
      bottom: 5px;
      width: 366px;
      height: 23px;
      background: url('~@/img/agriculture/title_line.png') 100% 100%;
    }
  }

  .chart-container {
    width: 100%;
    height: calc(100% - 70px);
  }
}
</style>
